import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

export const TextHeaderIt = () => {
    return (
        <HighlightedText
            text="GIRA LA RUOTA E OTTIENI GIRI GRATUITI"
            highlights={[{ word: 'GIRI' }, { word: 'GRATUITI' }]}
            breakAfterWords={['OTTIENI']}
            className={styles.text_header}
        />
    )
}
